import React, { useState, useEffect } from "react";
import ReactFullpage from "@fullpage/react-fullpage";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "styles/scss/home.scss"; 

const {kakao} = window;

const Home = () => {

    const [isOpen, setIsOpen] = useState(false); 
    const toggleDropdown = (event) => {
      event.stopPropagation();
      setIsOpen((prev) => !prev);
    };

    // 추가
    useEffect(() => {
        // 카카오맵 그리기
        printKakaomap();
    }, []);

    // 카카오맵 그리기
    function printKakaomap() {
        // 지도를 표시할 div 
        var container = document.getElementById("map");
        var options = {
            // 지도의 중심좌표
            center: new kakao.maps.LatLng(35.567094, 129.249808),
            level: 2,
        };
        // 지도를 생성합니다
        var map = new kakao.maps.Map(container, options);

        // 마커가 표시될 위치입니다 
        var markerPosition  = new kakao.maps.LatLng(35.567094, 129.249808);

        // 마커를 생성합니다
        var marker = new kakao.maps.Marker({
            position: markerPosition
        });

        // 마커가 지도 위에 표시되도록 설정합니다
        marker.setMap(map);

        // 일반 지도와 스카이뷰로 지도 타입을 전환할 수 있는 지도타입 컨트롤을 생성합니다
        var mapTypeControl = new kakao.maps.MapTypeControl();

        // 지도에 컨트롤을 추가해야 지도위에 표시됩니다
        // kakao.maps.ControlPosition은 컨트롤이 표시될 위치를 정의하는데 TOPRIGHT는 오른쪽 위를 의미합니다
        map.addControl(mapTypeControl, kakao.maps.ControlPosition.TOPRIGHT);

        // 지도 확대 축소를 제어할 수 있는  줌 컨트롤을 생성합니다
        var zoomControl = new kakao.maps.ZoomControl();
        map.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);
    }

  return (
    <ReactFullpage
      // 풀페이지 기본 옵션 설정
      scrollingSpeed={1000} // 스크롤 속도 (1초)
      navigation 
      navigationTooltips={["home", "business", "performance", "our-location"]} 
      showActiveTooltip={false} 
      fitToSection={true}
      scrollBar={false} s
      anchors={["home", "business", "performance", "our-location"]}
      render={() => {
        return (
          <div className="home-main">
             {/* 메인배너 ------------------------------------------------ */}
            <div className="section home">
              <div className="main-tit">
                <span className="red red-size">엔</span>
                <span className="tit-size">정보기술은</span><br></br>
                <span className="tit-size02">사업파트너로서 끊임없는 연구와 기술 혁신으로<br></br>
                <span className="red tit-size02 "> 새로운 미래를 열어갑니다.</span></span>
              </div>
              <div className="mouse-scroll">
                <ul>
                  <li className="scroll-txt">scroll</li>
                  <li className="mouse">
                    <div className="mouse-icon"></div>
                  </li>
                  <li className="mouse-bottom">
                    <div className="mouseBottom-icon"></div>
                  </li>
                </ul>
              </div>
            </div>
            {/* 비즈니스 -------------------------------------------------- */}
            <div className="section business">
              <div className="business-txt">
                <h1>Business</h1>
                <p>
                  <span className="gray02 text-small">Since</span>
                  <span className="red red-txt">2003</span>
                </p>
                <p>(주)엔정보기술 창립</p>
              </div>

              <p className="business-txtP gray-txt">
              "보편적인 가치인 개개인의 행복을 최우선 순위로 서로 존중하고 신뢰하는 인간 중심의 회사를  추구합니다.<br></br>
              또한, 발빠르게 변화하는 환경에 민감하게 반응하고 고객의 요구에 정확히 부합하는 솔루션을 구축해 갑니다."
              </p>

              <div className="circle-box">
                <div className="circle">
                  <div className="circle-flex">
                    <span className="server-icon"></span>
                    <span className="circle-txt">서버</span>
                  </div>
                </div>
                <div className="circle circle-red">
                  <div className="circle-flex">
                    <span className="development-icon"></span>
                    <span className="circle-txt">IT개발</span>
                  </div>
                </div>
                <div className="circle circle-red">
                  <div className="circle-flex">
                    <span className="network-icon"></span>
                    <span className="circle-txt">네트워크</span>
                  </div>
                </div>
                <div className="circle">
                  <div className="circle-flex">
                    <span className="Maintenance-icon"></span>
                    <span className="circle-txt">유지보수</span>
                  </div>
                </div>
              </div>
            </div>

             {/* 회사성과 -------------------------------------------------- */}
            <div className="section Performance">
              <div className="red-box">
                <p className="mobile-tit">Performance</p>
                <ul className="performance-ul container">
                  <li>
                    <span>회사설립</span>
                    <span className="company-icon"></span>
                    <span className="mobile-line"></span>
                    <span className="performance-txt">2003</span>
                  </li>
                  <li>
                    <span>솔루션 & 서비스</span>
                    <span className="solution-icon"></span>
                    <span className="mobile-line"></span>
                    <span className="performance-txt">+126</span>
                  </li>
                  <li>
                    <span>인증 & 마크</span>
                    <span className="certification-icon"></span>
                    <span className="mobile-line"></span>
                    <span className="performance-txt">+6</span>
                  </li>
                  <li>
                    <span>상표등록</span>
                    <span className="trademark-icon"></span>
                    <span className="mobile-line"></span>
                    <span className="performance-txt">+16</span>
                  </li>
                </ul>
              </div>
              <div>
                <p className="award-txt">"고객과 함께 성장하는 IT 파트너, 엔정보기술.<br></br>  <span className="red award-txt">변화와 혁신으로 비즈니스 가치</span>를 극대화합니다."</p>
              </div>
              <div className="award">
                {/* Swiper 슬라이더 */}
                <Swiper
                  spaceBetween={5} 
                  slidesPerView={1}
                  pagination={{ clickable: true }} 
                  grabCursor={true}
                  breakpoints={{
                    320: { slidesPerView: 1 }, 
                    480: { slidesPerView: 1 },
                    768: { slidesPerView: 2 }, 
                    1024: { slidesPerView: 3 }, 
                    1280: { slidesPerView: 5 },
                  }}
                  modules={[Pagination, Navigation]} 
                >
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                          <img src="/img/award/n-1.jpg" alt="엔정보기술 소프트웨어 사업자"></img>
                        </div>
                      </div>
                      <p>엔정보기술 소프트웨어 <br></br>사업자 확인서</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/n-2.jpg" alt="벤처기업 확인서"></img>
                        </div>
                      </div>
                      <p>벤처기업 확인서</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/n-3.jpg" alt="정보통신공사업등록증"></img>
                        </div>
                      </div>
                      <p>정보통신공사업등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/n-4.jpg" alt="기술혁신형 중소기업(Inno-Biz)확인서"></img>
                        </div>
                      </div>
                      <p>기술혁신형 중소기업 <br></br>(Inno-Biz)확인서</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/n-5.jpg" alt="기업부설연구소 인정서"></img>
                        </div>
                      </div>
                      <p>기업부설연구소 인정서</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-01.jpg" alt="긴급출동스마트차량관제 영상시스템 저작권 등록증"></img>
                        </div>
                      </div>
                      <p>긴급출동스마트차량관제 영상시스템 <br></br>저작권 등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-02.jpg" alt="자산관리시스템 저작권 등록증"></img>
                        </div>
                      </div>
                      <p>자산관리시스템 <br></br>저작권 등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-03.jpg" alt="비콘 위치기반 출동지 관제시스템 저작권 등록증"></img>
                        </div>
                      </div>
                      <p>비콘 위치기반 출동지 관제시스템 <br></br>저작권 등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-04.jpg" alt="사물인터넷(IOT)실내환경자원관리시스템 저작권 등록증"></img>
                        </div>
                      </div>
                      <p>사물인터넷(IOT)실내환경자원관리시스템 <br></br>저작권 등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-05.jpg" alt="정보통신기술(ICT)기반 한우관리시스템 저작권 등록증"></img>
                        </div>
                      </div>
                      <p>정보통신기술(ICT)기반한우관리시스템 (web)저작권 등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-06.jpg" alt="정보통신기술(ICT)기반 한우관리시스템 (모바일)저작권 등록증"></img>
                        </div>
                      </div>
                      <p>정보통신기술(ICT)기반한우관리시스템 <br></br>(모바일)저작권 등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-07.jpg" alt="국가산업단지 위험물관리시스템저작권 등록증"></img>
                        </div>
                      </div>
                      <p>국가산업단지 위험물관리시스템<br></br>저작권 등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-08.jpg" alt="양액 자동공급장치 데이터 모니터링 API 프로그램 저작권 등록증"></img>
                        </div>
                      </div>
                      <p>양액 자동공급장치 데이터 모니터링 <br></br>API 프로그램 저작권 등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-09.jpg" alt="양액 자동 공급 장치 제어 프로그램 저작권 등록증"></img>
                        </div>
                      </div>
                      <p>양액 자동 공급 장치 제어 프로그램<br></br>저작권 등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-10.jpg" alt="장비이력관리솔루션 프로그램 등록증"></img>
                        </div>
                      </div>
                      <p>장비이력관리솔루션<br></br>프로그램 등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-11.jpg" alt="소방본부 차량관제 서비스 솔루션 프로그램 등록증"></img>
                        </div>
                      </div>
                      <p>소방본부 차량관제서비스 솔루션<br></br>프로그램 등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-12.jpg" alt="인보이스 자동화 솔루션 프로그램 등록증"></img>
                        </div>
                      </div>
                      <p>인보이스 자동화 솔루션<br></br>프로그램 등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-13.jpg" alt="위치기반 안심보호망 관리 솔루션 프로그램 등록증"></img>
                        </div>
                      </div>
                      <p>위치기반 안심보호망 관리 솔루션<br></br>프로그램 등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-14.jpg" alt="서버룸작업지원용로봇 디자인등록증"></img>
                        </div>
                      </div>
                      <p>서버룸작업지원용로봇디자인<br></br>디자인등록증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-15.jpg" alt="무인비행체를 이용한 배낭형 재난 관측 장치 특허증"></img>
                        </div>
                      </div>
                      <p>무인비행체를 이용한 <br></br>배낭형 재난 관측 장치 특허증</p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="award-card">
                      <div className="award-img-size">
                        <div className="award-img">
                        <img src="/img/award/nAward-16.jpg" alt="혼합현실제공서비스를 위한 안내판, 그것을 이용한 3D 형상 정보 제공자치 및 그 방법 특허증"></img>
                        </div>
                      </div>
                      <p>혼합현실제공서비스를 위한 안내판, 그것을 이용한 3D 형상 정보 제공자치 및 그 방법 특허증</p>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>

            {/* 오시는길 -------------------------------------------------- */}
            <div className="section map">
                <div className="home-map">
                  <h1>Our Location</h1>
                  <p className="address-txt">(44921)울산광역시 울주군 범서읍 대리로 89 경동빌딩 2~5층</p>

                  <div className="map-boxG" id="map">
                    <span className="map-box"></span>
                  </div>
                </div>
             {/* 푸터 -------------------------------------------------- */}
                <div className="home-footer">
                  <ul className="footer-information container">
                    <li className="footer-logo">
                        <span className="logo-img"></span>
                    </li>
                    <li className="footer-InforTxt">
                      <div className="inforTxt-2">
                        <span>(44921)울산광역시 울주군 범서읍 대리로 89 경동빌딩 2~5층</span>
                        <span>전화 : 052-246-1331</span>
                        <span>팩스 : 052-246-1991</span>
                      </div>
                    </li>
                    <li className="familySite">
                      <div onClick={toggleDropdown} className="familySite-button">FAMILY SITE </div>
                      {/* 드롭다운 메뉴 */}
                      {isOpen && (
                        <ul className={`dropdown-menu ${isOpen ? "open" : "닫힘"}`}>
                        <li><a href="http://itnn.kr/" target="_black">아이티엔</a></li>
                      </ul>
                      )}
                    </li>
                  </ul>
                  <div className="footer-blackBox">
                    <p>© Ntek. All Rights Reserved.</p>
                  </div>
                </div>
                </div>

            </div>
        );
      }}
    />
  );
};

export default Home;
